<template>
  <div>
    <div class="load-more-tickets">
      <span class="btn btn-sm btn-success" href="#" @click="abrirmodalTarima()">
        <span><i class="fas fa-plus"></i> Crear Tarima</span>
      </span>
    </div>
    <br>
    <div class="modal fade" id="crearTarimaModal" role="dialog" tabindex="-1" aria-hidden="true" style="display: none">
      <div class="modal-dialog" role="document">
        <div v-bind:style="current.tipo == 'D'
          ? 'background-color: #f6ffdb'
          : 'background-color: white;'
          " class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">
              <span>Crear tarima</span>
            </h6>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true"> ×</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="form-group">
              <label v-bind:class="{
                'text-danger': current.errors && current.errors.tienda,
              }">
                Tienda Origen
              </label>
              <select class="form-control" autofocus="autofocus" v-model="current.tienda_origen"
                :disabled="current.id != null" @change="selectTienda()">
                <option v-for="(tienda, key) in tiendas" :value="tienda.codigo" :key="key">
                  {{ tienda.codigo }} - {{ tienda.nombre }}
                </option>
              </select>
              <small v-if="current.errors && current.errors.tienda_origen" class="form-text text-danger">{{
                current.errors.tienda_origen[0] }}</small>
            </div>
            <TiendaSelectComponent titulo="Tienda Destino" :current="current" />
            <small v-if="current.errors && current.errors.tienda_destino" class="form-text text-danger">{{
              current.errors.tienda_destino[0] }}</small>
            <small v-if="error_tarima" class="form-text text-danger">
              {{ error_tarima }}
            </small>
            <div>
              <label>Barra de posición</label>
              <input class="form-control" type="text" v-model="current.barra_posicion_origen" />
              <br />
            </div>
            <div class="col-12">
              <span class="font-weight-bold text-dark text-center">Crear tarima desde estación:
              </span>
              <label class="switch">
                <input :disabled="current.tienda_origen != '01'" class="text-center" v-model="current.tarima_estacion"
                  type="checkbox" />
                <span class="slider-button"></span>
              </label>
            </div>

            <hr />
            <span class="font-weight-bold">Tipo de tarima:</span>
            <div class="col-12">
              <ul class="nav nav-pills mt-2 mb-3">
                <div class="col-6">
                  <li class="nav-item">
                    <a @click="setT()" data-toggle="tab" href="#" class="nav-link btn btn-block" style="font-size: 12px"
                      v-bind:style="current.tipo == 'T'
                        ? 'background-color: #00A2FF; color: #FFFFFF;'
                        : 'color: #929292;'
                        " :class="{ active: current.tipo == 'T' }">Traslado</a>
                  </li>
                </div>
                <div class="col-6">
                  <li class="nav-item">
                    <a @click="setD()" data-toggle="tab" href="#" class="nav-link btn btn-block" v-bind:style="current.tipo == 'D'
                      ? 'background-color: orange; color: #FFFFFF;'
                      : 'color: #929292;'
                      " :class="{ active: current.tipo == 'D' }" style="font-size: 12px">
                      Devolución
                    </a>
                  </li>
                </div>
              </ul>
            </div>
            <button v-if="current.tarima_estacion == true" class="btn btn-block" @click="afterCrearTarima()" v-bind:class="{
              'btn-primary': current.tipo == 'T',
              'btn-danger': current.tipo == 'D',
            }">
              Continuar <i class="fas fa-check"></i>
            </button>
            <button v-if="current.tarima_estacion == false && current.tipo == 'T'" class="btn btn-block btn-primary"
              @click="afterCrearTarima()">
              Crear tarima traslado <i class="fas fa-check"></i>
            </button>
            <button v-if="current.tarima_estacion == false && current.tipo == 'D'" class="btn btn-block btn-danger"
              @click="afterCrearTarima()">
              Crear tarima devolución <i class="fas fa-check"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalExistencias1" role="dialog" tabindex="-1" aria-hidden="true" style="display: none">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title text-center">
              ¡Estos son los productos que hay en la
              estación!
            </h6>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true"> ×</span>
            </button>
          </div>
          <div style="height: 350px; overflow: auto" class="modal-body">
            <table class="table table-compact smaller text-faded mb-0">
              <thead>
                <tr>
                  <th>Producto</th>
                  <th>Cantidad</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="existencia in existencias" :key="existencia.id">
                  <td class="text-bright">
                    {{ existencia.sku }} - {{ existencia.nombre_sku }}
                  </td>
                  <td v-bind:class="{
                    'text-danger': existencia.cantidad < 0,
                  }" class="text-right text-success">
                    {{ existencia.cantidad }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button @click="crearTarimaDeseEstacion()" class="btn btn-primary btn-block btn-md">
              Crear tarima <i class="fas fa-check"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    TiendaSelectComponent,
  },
  props: {
    id_tarima: {
      type: String,
    },
  },
  data() {
    return {
      existencias: [],
      current: {
        tarima_estacion: false,
        tipo: "T",
        tienda_origen: "02",
        tienda: null,
        errors: {},
      },
      error_tarima: null,
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  mounted() { },
  methods: {
    selectTienda() {
      let self = this;

      if (self.current.tienda_origen != "02") {
        self.current.tarima_estacion = false;
      }
    },
    setT() {
      let self = this;
      self.current.tipo = "T";
    },
    setD() {
      let self = this;
      self.current.tipo = "D";
    },
    abrirmodalTarima() {
      $("#crearTarimaModal").modal("show");
    },
    VerInventarioEstacion() {
      let self = this;
      $("#crearTarimaModal").modal("hide");
      $("#modalExistencias1").modal("show");
      DynamicService.getActionList(
        "wms",
        "picking-despacho",
        "inventario_posicion",
        {
          barra_posicion: self.current.barra_posicion_origen,
        }
      )
        .then((response) => {
          self.existencias = response.data;
          self.barra_posicion = "";
          $("#modalExistencias1").modal("show");
        })
        .catch((errors) => {
          Notifications.alert.error(
            "Inventario de estación",
            errors.response.data.detail
          );
        });
    },
    crearTarimaDeseEstacion() {
      let self = this;
      DynamicService.postActionList(
        "wms",
        "tarima",
        "crear_tarima_desde_estacion",
        {
          tienda_origen: self.current.tienda_origen,
          tienda_destino: self.current.tienda,
          barra_posicion_origen: self.current.barra_posicion_origen,
          tipo_tarima: self.current.tipo,
        }
      )
        .then((res) => {
          $("#modalExistencias1").modal("hide");
          self.$emit("refresh");
          console.log(res.data.agregar_producto_a_tarima);
          if (res.data.agregar_producto_a_tarima[0]) {
            let productos_no_entarimados =
              res.data.agregar_producto_a_tarima.toString();
            Notifications.alert.error(
              "Los siguientes productos no fueron entarimados.",
              `${productos_no_entarimados} por falta de solicitud o problemas con la estacion, "REVISE LA TARIMA POR FAVOR"`,
              ""
            );
          }
          if (self.current.tipo == "D") {
            self.$router.push({
              name: "wms-devolucion-tarima-editar",
              params: { id: res.data.tarima_id },
            });
            return;
          }
          if (self.current.tipo == "T") {
            self.$router.push({
              name: "wms-tarimas-editar",
              params: { id: res.data.tarima_id },
            });
            $("#modalExistencias1").modal("hide");
            self.$emit("refreshCurrent");
            return;
          }
        })
        .catch((err) => {
          console.log(err.response.data);
          if (err.response.data.tarima) {
            self.error_tarima = err.response.data.tarima;
          }
          if (err.response.data.detail) {
            Notifications.alert.error(
              "Crear nueva tarima desde estación",
              err.response.data.detail
            );
          }
        });
    },
    afterCrearTarima() {
      let self = this;
      let message;
      if (self.current.tipo == "T") {
        message = "Usted creara una tarima para TRASLADO, ¿Esta seguro(a)?";
      }
      if (self.current.tipo == "D") {
        message = "Usted creara una tarima para DEVOLUCIÓN, ¿Esta seguro(a)?";
      }
      if (self.current.tarima_estacion == true) {
        if (!self.current.tienda) {
          Notifications.alert.error(
            "Crear tarima",
            "Por favor elija una tienda destino antes de continuar"
          );
          return;
        }
        if (!self.current.barra_posicion_origen) {
          Notifications.alert.error(
            "Crear tarima",
            "Por favor elija una posicion de estación"
          );
          return;
        }
        self.VerInventarioEstacion();
        return;
      }
      Notifications.alert.confirm_danger(
        "¡Aviso Importante!",
        message,
        "",
        function () {
          self.crearTarimaSubmit();
        }
      );
    },
    crearTarimaSubmit() {
      let self = this;
      DynamicService.save("wms", "tarima", {
        tienda_origen: self.current.tienda_origen,
        tienda_destino: self.current.tienda,
        barra_posicion_origen: self.current.barra_posicion_origen,
        tarima_devolucion: self.current.tipo,
      })
        .then((res) => {
          self.$emit("refreshCurrent");
          if (self.current.tipo == "D") {
            self.$router.push({
              name: "wms-devolucion-tarima-editar",
              params: { id: res.data.id },
            });
          }
          if (self.current.tipo == "T") {
            self.$router.push({
              name: "wms-tarimas-editar",
              params: { id: res.data.id },
            });
          }
          $("#crearTarimaModal").modal("hide");
        })
        .catch((err) => {
          self.current.errors = err.response.data;
          console.log(err.response.data);
          if (err.response.data.tarima) {
            self.error_tarima = err.response.data.tarima;
          }
          if (err.response.data.detail) {
            Notifications.alert.error(
              "Crear nueva tarima",
              err.response.data.detail
            );
          }
        });
    },
    crearTarimaSinRequisicion() {
      let self = this;
      DynamicService.save("wms", "tarima", {
        tienda_origen: self.current.tienda_origen,
        tienda_destino: self.current.tienda,
        barra_posicion_origen: self.current.barra_posicion_origen,
        sin_solicitud: true,
      })
        .then((res) => {
          self.$emit("refresh");
          $("#crearTarimaModal").modal("hide");
        })
        .catch((err) => {
          if (err.response.data.tarima) {
            self.error_tarima = err.response.data.tarima;
          }
          if (err.response.data.detail) {
            Notifications.alert.error(
              "Crear nueva tarima",
              err.response.data.detail
            );
          }
        });
    },
  },
};
</script>
